import React from 'react'
import ReactDOM from 'react-dom'
import { AppConfigProvider } from './AppConfigContext'
//import { DevBuild } from 'variables/Config'

import {
    HashRouter,
    Route // ,    Switch //,     Redirect
} from 'react-router-dom';

import App from 'containers/App/App.jsx';
import Login from 'containers/Login/Login';

//import { UserCred } from 'variables/Users'

import './assets/css/bootstrap.min.css';
import './assets/css/animate.min.css';
//import './assets/sass/light-bootstrap-dashboard.css';
import './assets/css/light-bootstrap-dashboard.min.css'; // freezed on 2019 07 20
import './assets/css/demo.css';
import './assets/css/pe-icon-7-stroke.min.css';


class MainLogin extends React.Component {
  constructor(props){
    super(props)
    this.state = { token : "" , hosturl:''}
    this.inLogin = this.inLogin.bind(this)
    this.setHostUrl = this.setHostUrl.bind(this)
  }
  componentDidMount(){
    /*if (DevBuild) {
      // mockup
      let token_val ={
        token: "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95YWhhdiIsImlhdCI6MTU1Mzc0OTEwMywibmJmIjoxNTUzNzQ5MTAzLCJleHAiOjE1NTQzNTM5MDMsImRhdGEiOnsidXNlciI6eyJpZCI6IjYifX19.EYyLKfdsnUetVOgWXjanX13YXTXK3MogjcF17k1eUd0",
        user_display_name: "איילת",
        user_email: "ayeletnegev.yahav@gmail.com",
        user_nicename: "ayeletnegev",
        user_role: ['administrator']
      }
      this.setState({token:token_val})
    }*/
  }
  
  inLogin = (token) => {
    ////console.log("inlogin= token", token)
    this.setState({token:token})
  }

  setHostUrl = (url) => {
    ////console.log("inlogin= token", token)
    this.setState({hosturl:url})
  }

  render(){
    const { token, hosturl } = this.state
    //console.log("inlogin= token", token)
    //{/*<Login loginres={this.inLogin} />*/}
    return (
      <AppConfigProvider>
          <HashRouter>
            {token === "" ? <Login loginres={this.inLogin} hosturl={this.setHostUrl} /> 
                : <Route path="/"  render = { (props) => <App mbouser={token} hosturl={hosturl} {...props} /> } />
            }
          </HashRouter>
      </AppConfigProvider>
    )
  }
}
ReactDOM.render( <MainLogin />, document.getElementById('root'))
//                 : <Route path="/" name="Home" render = { (props, token) => <App user={token} {...props} /> } />

